import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { startDate, endDate } from '@/utils/date';
import { Taxpayers } from '@/store/types';
import { statuses, taxpayerTypes } from '@/store/mapping';
import { dateFormat, numGroup } from '@/utils/filters';

export default class BusinessTaxpayersStore extends ListStore {
  @override
  filters = {
    name: '',
    tin: '',
    createDate: '',
    createType: '',
    type: null,
    status: null,
    isExceed: false,
    startDate,
    endDate,
  };
  @observable overall = {
    totalIncome: 0,
    totalTax: 0,
  };

  @computed get processedData() {
    if (!this.data?.items || !this.data?.items?.length) return;
    const items = this.data.items.map((item: Taxpayers) => ({
      ...item,
      type: taxpayerTypes[item.type] || '-',
      createDate: dateFormat(item.createDate, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumIncome: numGroup(item.sumIncome),
      sumTax: numGroup(item.sumTax),
    }));

    return { ...this.data, items };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const {
        data: { totalIncome, totalTax, ...data },
      } = await services.business.getTaxpayersList({
        ...this.notFalsyParams,
        taxMode: 'AUSN',
        type: 'UL',
      });
      this.data = data;
      this.overall = { totalIncome, totalTax };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
